import React from 'react'
import { VFSBrowser } from './file-explorer-front'

const SandBoxStroage = () => {
  return (
    <VFSBrowser/>
  )
}

export default SandBoxStroage